/**
 * Role identifiers that mirror what the backend stores.
 * The frontend uses these strings for type safety only; the actual permissions
 * a role grants are decided by the backend and returned in user.permissions.
 */
export const ROLES = {
  SUPER_ADMIN: 'super_admin',
  ADMIN: 'admin',
  MANAGER: 'manager',
  SUPPORT: 'support',
  VIEWER: 'viewer',
} as const

export type Role = (typeof ROLES)[keyof typeof ROLES]

export const ROLE_LABEL_KEY: Record<Role, string> = {
  super_admin: 'roles.names.super_admin',
  admin: 'roles.names.admin',
  manager: 'roles.names.manager',
  support: 'roles.names.support',
  viewer: 'roles.names.viewer',
}
